export enum TrackRecordSourceEnum {
  BACKTESTING = 'BACKTESTING',
  REAL = 'REAL',
}
